export default '/build/75f06760.svg'